import Constants from '../utils/constants';

const TAB_INDEXES = Constants.TAB_INDEXES;

export default {
  tabs: {
    dac_type: {
      name: 'dac-type',
      index: TAB_INDEXES.DAC_TYPE,
      default: true,
      disableIfNoSelectedDac: false,
    },
    application_parameters: {
      name: 'application-parameters',
      index: TAB_INDEXES.APP_PARAMS,
      disableIfNoSelectedDac: true,
    },
    circuit_design: {
      name: 'circuit-design',
      index: TAB_INDEXES.CIRCUIT_DESIGN,
      disableIfNoSelectedDac: true,
    },
  },
};
